import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function Guarantee() {
  return <section className="w-full bg-cream paper-grain" data-id="element-48" data-mp="1o2vjmvsbez9q">
      <div className="mx-auto w-full max-w-3xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-49" data-mp="22367rr28pzr7">
        <div className="rounded-[1.75rem] border border-sage/40 bg-white/60 p-6 text-center sm:rounded-[2rem] sm:p-12" data-id="element-50" data-mp="1x4bs2xzkkrbb">
          <span className="mx-auto mb-5 flex h-12 w-12 items-center justify-center rounded-full bg-sage/20 text-moss sm:mb-6 sm:h-14 sm:w-14" data-id="element-51" data-mp="19e7qew5xz1my">
            <ShieldCheckIcon className="h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-52" data-mp="14hhac8u5061j" />
          </span>
          <h2 className="font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-53" data-mp="1j5vaud42ziex">
            Garantía de Satisfacción de 7 días
          </h2>
          <p className="mx-auto mt-4 max-w-xl font-sans text-[15px] leading-relaxed text-ink/70 sm:mt-5 sm:text-base" data-id="element-54" data-mp="qnpy2sp0u824">
            Tenés 7 días para revisar todo el material. Si sentís que no podés
            hacer tus jabones o no te gusta el recetario, te devolvemos el 100%
            de tu dinero.
          </p>
          <p className="mt-4 font-display text-lg italic text-clay sm:text-xl" data-id="element-55" data-mp="txkuz618zc15">
            El riesgo es todo mío.
          </p>

          <div className="mt-7 sm:mt-9" data-id="element-56" data-mp="yq4iovtnfnjo">
            <CtaButton className="mx-auto" data-id="element-57" data-mp="12qoffyab8p5a" />
          </div>
        </div>
      </div>
    </section>;
}